module.exports = __webpack_public_path__ + "static/media/solutions-outsource.5a4c5edc.svg";